import {ThemeSpacingNames} from '../../types';

export const Spacing: ThemeSpacingNames = {
  '1': 1,
  '2': 2,
  '4': 4,
  '6': 6,
  '8': 8,
  '10': 10,
  '12': 12,
  '14': 14,
  '16': 16,
  '18': 18,
  '20': 20,
  '24': 24,
  '28': 28,
  '32': 32,
  '36': 36,
  '40': 40,
  '48': 48,
  '56': 56,
  '64': 64,
  '96': 96,
  '128': 128,
};
